import { FunctionComponent } from 'react'
import styled from 'styled-components'

export const Spinner = styled.span`
  display: inline-block;
  width: 15px;
  height: 15px;
  border: 2px solid #ec5990;
  border-radius: 50%;
  border-top-color: white;
  animation: spin 0.7s ease-in-out infinite;
  -webkit-animation: spin 0.7s ease-in-out infinite;
  margin-left: 10px;
  margin-bottom: -5px;
`

export const SpinLoader: FunctionComponent = () => {
  return <Spinner />
}
